import { ExpandableSection } from "routes/skus/components/expandable-section";
import Spinner from "../../../components/Spinner";
import { DateTimeFormat } from "../../../libraries/date-time-format/date-time-format";

function ArtworkRequestHistoryTable(props: {
  historyRecords: any[];
  isLoading?:boolean;
}) {

  const statusOrder = {
    "APPROVED": 1,
    "REJECTED": 2,
    "SUBMITTED": 3,
    "CREATED": 4
  };

  return (
    <div className="mt-3">
      <ExpandableSection
        sectionId={"tcc-view-request-history"}
        title="Request History"
        expandedByDefault={true}
      >
        <div className="molds-table-container">
          {props.isLoading ? (
            <Spinner />
          ) : (
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Timestamp</th>
                  <th scope="col">User</th>
                  <th scope="col">User Location</th>
                  <th scope="col">Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                {props.historyRecords
                  .sort((a, b) => {
                    // @ts-ignore
                    const aPriority = statusOrder[a.status.status];
                    // @ts-ignore
                    const bPriority = statusOrder[b.status.status];

                    // Compare the priorities
                    return aPriority - bPriority;
                  })
                  .map((history: any, index)  => {
                  return (
                    <tr key={index}>
                      <td>{`${history.status.status}`}</td>
                      <td>{DateTimeFormat.formatTimestamp(history.date)}</td>
                      <td>{`${history.user.first_name} ${history.user.last_name}`}</td>
                      <td>{history.user.location.name}</td>
                      <td>{history.comment}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </ExpandableSection>
    </div>
  );
}

export default ArtworkRequestHistoryTable;
